import React, { FunctionComponent } from 'react';
import * as SocrataVisualizations from 'common/visualizations';
import { ComponentBase } from 'lib/components/block-component-renderers/shared/ComponentBase';
import 'lib/components/block-component-renderers';
import 'lib/components/Modal';
import { BlockComponent, ComponentType } from 'types';

interface Props {
  component: BlockComponent;
  blockId: string;
  componentIndex: number;
}

// TODO: why is this here and also in view/index?
/**
 * The `setup` function is in a JS file and defines two arguments.
 * JS lets you not pass in any arguments, while TS doesn't. We need to
 * fix the signature of the `setup` function in order to remove this.
 */
// @ts-expect-error
SocrataVisualizations.views.RowInspector.setup();

const ViewBlockItem: FunctionComponent<Props> = (props) => {
  const { component, componentIndex, blockId } = props;

  const containerClasses = [`col${component.layout.w}`];
  if (component.type !== ComponentType.GLOBAL_FILTER) {
    containerClasses.push('flexible-component');
  }

  return (
    <ComponentBase
      blockId={blockId}
      componentIndex={componentIndex}
      containerClasses={containerClasses}
      editMode={false}
    />
  );
};

export default ViewBlockItem;
